"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const useDisclosureContext_1 = require("./useDisclosureContext");
const color_1 = require("../../constants/color");
const theme_1 = require("../../constants/theme");
const BodyElement = styled_1.default.div((props) => ({
    backgroundColor: props.floating ? undefined : color_1.Color.WHITE,
    border: props.floating ? undefined : theme_1.theme.border.style.thin,
    borderBottomLeftRadius: theme_1.theme.border.radius.normal,
    borderBottomRightRadius: theme_1.theme.border.radius.normal,
    borderTop: 'none',
    display: props.open ? 'block' : 'none',
    padding: props.floating ? 0 : 20,
    paddingTop: props.floating ? 8 : undefined,
}));
const Body = ({ alwaysRender, children }) => {
    const { floating, isOpen } = (0, useDisclosureContext_1.useDisclosureContext)();
    return alwaysRender || isOpen ? ((0, jsx_runtime_1.jsx)(BodyElement, { floating: floating, open: isOpen, children: children })) : null;
};
exports.Body = Body;
